import { FormikSingleSelect } from '~/components/Formik/FormikSingleSelect';
import { IMAGE_FORMAT_SINGLE_SELECT } from '~/constants/testIDs';
import { SUPPORTED_EXPORT_FORMATS } from '~/utils/Imgix';

const extensionOptions = SUPPORTED_EXPORT_FORMATS.map((format) => ({
  label: format.toUpperCase(),
  value: format,
}));

export type ExportImageExtSelectProps = {
  setIsEditing: (isEditing: boolean) => void;
};

export const ExportImageExtSelect = ({ setIsEditing }: ExportImageExtSelectProps) => {
  return (
    <FormikSingleSelect
      isSearchable={false}
      size="extra-large"
      data-testid={IMAGE_FORMAT_SINGLE_SELECT}
      label="Format"
      name="ext"
      options={extensionOptions}
      onOptionsClose={() => {
        setIsEditing(false);
      }}
      onOptionsOpen={() => {
        setIsEditing(true);
      }}
      className="min-w-[157px]"
    />
  );
};
